<!--
  a11y: audit reported the POI results page was inaccessible to SR users.
  Wrapping the station cards in a proper <ul> with [attr.aria-label] makes
  SR announce "list, N items" and gives each card an <li> wrapper so
  navigation by "list item" command works. role="list" is repeated even
  though <ul> already has the role implicitly - some SR (VoiceOver) drop
  the list role when CSS list-style is "none", and our Tailwind reset does
  exactly that. The list label uses the existing STATIONS_LIST constant
  (already localized).
-->
<ul
  role="list"
  class="max-h-full p-4 flex flex-col gap-4 list-none m-0"
  [attr.aria-label]="stationsListAriaLabel"
>
  @for (stationItem of stations; track stationItem; let i = $index) {
    <li>
      <app-search-stations-result-list-item
        [station]="stationItem"
        [positionInSet]="i + 1"
        [setSize]="stations.length"
        (onPickStation)="pickStation(stationItem)"
        (onFoucs)="
          routePlanningService._resultSubject.next({
            type: 'highlighted',
            value: $event
          })
        "
      />
    </li>
  }
</ul>
